import {computed} from 'vue'
import useI18nExtended from '~/composables/usei18nExtended'

export const useFormPrivacyText = () => {
  const i18n = useI18nExtended()

  const privacyPolicyText = computed(() => {
    const translatedText = i18n.tv('formPrivacyPolicyText', 'leadform')
    return translatedText + '*'
  })

  const privacyPolicyTextRaw = computed(() => {
    return i18n.tv('formPrivacyPolicyText', 'leadform')
  })

  const privacyPolicyLinkHtml = computed(() => {
    const textRaw = privacyPolicyTextRaw.value || ''

    return textRaw.replace(
      /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/gi,
      '<a class="link" href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    )
  })

  return {
    privacyPolicyText,
    privacyPolicyTextRaw,
    privacyPolicyLinkHtml
  }
}
